import mt from './mutationTypes'

const mutations = {
  [mt.setCode](state, code) {
    state.code = code
  },
  [mt.setShowSideBar](state, showSideBar) {
    state.showSideBar = showSideBar
  },
  [mt.setShowCode](state, showCode) {
    state.showCode = showCode
  },
  [mt.setPhoneMode](state, phoneMode) {
    state.phoneMode = phoneMode
  },
  [mt.setDisplayWidth](state, displayWidth) {
    state.displayWidth = displayWidth
  },

  [mt.setLanguage](state, language) {
    if (_.get(state.imported, language)) location.reload()
    _.set(state.imported, language, true)
    state.language = language
  },
  [mt.setLanguageCallback](state, languageCallback) {
    state.languageCallback = languageCallback
  },
  [mt.setLanguagePopupData](state, languagePopupData) {
    state.languagePopupData = languagePopupData
  },

  [mt.setUserInfo](state, userInfo) {
    state.userInfo = userInfo
  },
  [mt.setProject](state, project) {
    state.project = project
  },
  [mt.setDevices](state, devices) {
    state.devices = devices
  },
  [mt.setMyDevices](state, myDevices) {
    state.myDevices = myDevices
  },
  [mt.setDevice](state, device) {
    state.device = device
  },
  [mt.setTabs](state, tabs) {
    state.tabs = tabs
  },
  [mt.setFilteredTabs](state, filteredTabs) {
    state.filteredTabs = filteredTabs
  },
  [mt.setIsAdmin](state, isAdmin) {
    state.isAdmin = isAdmin
  },
  [mt.setIsModified](state, isModified) {
    state.isModified = isModified
  },
  [mt.setIsPublish](state, isPublish) {
    state.isPublish = isPublish
  },
  [mt.setBlocklyXml](state, blocklyXml) {
    state.blocklyXml = blocklyXml
  },
  [mt.setLoginData](state, loginData) {
    state.loginData = loginData
  },
  [mt.setUserPopupData](state, userPopupData) {
    state.userPopupData = userPopupData
  },
  [mt.setPasswordPopupData](state, passwordPopupData) {
    state.passwordPopupData = passwordPopupData
  },
  [mt.setLeavePopupData](state, leavePopupData) {
    state.leavePopupData = leavePopupData
  },
  [mt.setInfoPopupData](state, infoPopupData) {
    state.infoPopupData = infoPopupData
  },
  [mt.setEmailVerificationPopupData](state, emailVerificationPopupData) {
    state.emailVerificationPopupData = emailVerificationPopupData
  },
  [mt.setMessagePopupData](state, messagePopupData) {
    state.messagePopupData = messagePopupData
  },
  [mt.setConfirmPopupData](state, confirmPopupData) {
    state.confirmPopupData = confirmPopupData
  },

  [mt.setOpenProjectPopupData](state, openProjectPopupData) {
    state.openProjectPopupData = openProjectPopupData
  },
  [mt.setSaveProjectPopupData](state, saveProjectPopupData) {
    state.saveProjectPopupData = saveProjectPopupData
  },
  [mt.setRenameProjectPopupData](state, renameProjectPopupData) {
    state.renameProjectPopupData = renameProjectPopupData
  },
  [mt.setUrlEditProjectPopupData](state, urlEditProjectPopupData) {
    state.urlEditProjectPopupData = urlEditProjectPopupData
  },
  [mt.setProjectDetailPopupData](state, projectDetailPopupData) {
    state.projectDetailPopupData = projectDetailPopupData
  },
  [mt.setAddDevicePopupData](state, addDevicePopupData) {
    state.addDevicePopupData = addDevicePopupData
  },
  [mt.setHelpPopupData](state, helpPopupData) {
    state.helpPopupData = helpPopupData
  }
}

export default mutations
